//Creates new ExperimentPoster and assigns ID and type
export const createExperimentPoster = (data) => {
    //data = {id, type}
    return { type: "CREATE_EXPERIMENT_POSTER", payload: data}
}
